import { useQuery } from '@tanstack/react-query'
import { fetchOffshoreTableOverviewData } from 'services/verticalsTablesApi'
import { IOffshoreOverviewData } from 'containers/OffshoreTablePage/BusinessSummary/utils'
import { Filter } from 'components/FilterDrawer/FilterDrawer.config'

interface UseVerticalOverviewQueryProps {
  verticalIndices: string
  currentQueryKey: string
  searchValue?: string
  filters?: Filter[]
}

export const useOffshoreOverviewQuery = <T extends IOffshoreOverviewData>({
  verticalIndices,
  currentQueryKey,
  searchValue,
  filters,
}: UseVerticalOverviewQueryProps) =>
  useQuery<T | null>({
    queryKey: [currentQueryKey, verticalIndices, searchValue, filters],
    queryFn: () => (verticalIndices ? fetchOffshoreTableOverviewData(verticalIndices, searchValue, filters) : null),
  })
